import NotFound from "@/components/AppRouter/NotFound";
import Container from "@/components/ContentContainer/Container";
import { PageHeader } from "@/components/PageHeader/PageHeader";
import { useGetCompanies, useGetUser, usePatchUser } from "@/hooks/useAdmin";
import useTranslation from "@/hooks/useTranslation";
import { useUserSettings } from "@/hooks/useUserSettings";
import { Button, Flex, Form, Input, Select, message } from "antd";
import { useForm } from "antd/es/form/Form";
import { useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";

export default function User() {
  const { userId: id } = useParams();
  const userId = Number(id);

  const [form] = useForm();
  const { data: userSettings } = useUserSettings();
  const { data: user, isLoading: userIsLoading } = useGetUser({ userId });
  const { data: companies, isLoading: companiesLoading } = useGetCompanies();
  const userPatch = usePatchUser();
  const t = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    form.setFieldsValue({ ...user });
  }, [user]);

  if (userSettings && userSettings.role !== "root_admin") {
    return <NotFound />;
  }

  const onSubmit = () => {
    form.validateFields().then((values) => {
      userPatch
        .mutateAsync({
          userId,
          user: values,
        })
        .then((result) => {
          if (result.status === 200) {
            message.success("User saved succesfully.");
            navigate("/admin/users");
          }
        })
        .catch(() => {
          message.error(t.errors.general);
        });
    });
  };

  return (
    <Flex
      vertical
      gap={12}
    >
      <PageHeader
        title={user?.name}
        loading={userIsLoading}
        right={<Link to={`/companies/${user?.company_id}`}>Go to company</Link>}
      />
      <Container>
        <Form
          form={form}
          labelCol={{
            span: 8,
          }}
          wrapperCol={{
            span: 16,
          }}
          style={{
            maxWidth: 600,
          }}
          initialValues={user}
          autoComplete="off"
          layout={"vertical"}
        >
          <Form.Item
            required={true}
            label="Name"
            name="name"
          >
            <Input disabled={userIsLoading} />
          </Form.Item>
          <Form.Item
            required={true}
            label="Username"
            name="username"
          >
            <Input disabled={true} />
          </Form.Item>
          <Form.Item
            required={true}
            label="Email"
            name="email"
          >
            <Input disabled={true} />
          </Form.Item>
          <Form.Item
            required={true}
            label="Company"
            name="company_id"
          >
            <Select
              disabled={userIsLoading || (user && !["root_user", "root_admin"].includes(user.role))}
              loading={companiesLoading}
              options={companies?.map((c) => ({ label: `${c.id} - ${c.name}`, value: c.id }))}
            />
          </Form.Item>
          <Button
            disabled={userPatch.isLoading}
            loading={userPatch.isLoading}
            onClick={onSubmit}
            type="primary"
          >
            Save
          </Button>
        </Form>
      </Container>
    </Flex>
  );
}
